import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

function Select({ action, variables, setOpenVariable, variableRender }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATABASE.SELECT.';

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'QUERY')} is_required />
                <TextInput action={action} inputName="query" variables={variables} setOpenVariable={setOpenVariable} multiline isRequired={true} hideRequired />
                <small className="conf-field-desc"><em>Ex: select * from users</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'TIMEOUT')} />
                <TextInput action={action} inputName="timeout" variables={variables} setOpenVariable={setOpenVariable} />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.INPUT-VALUE-HELPER', { type: 'number' })}</em></small>
            </div>

            <div className="conf-field-container">
                <FieldLabel name={t('CONTENT.CONFIGURATION-FORM.REPEATABLE.REPEAT.ASSIGN_TO_VARIABLE')} is_required />
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    isRequired={true}
                    filter="data table"
                    hideRequired
                />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
        </div>
    )
}

export default Select;
